export default function Favourites(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={26.938} {...props}>
      <g fill="#051828">
        <path
          data-name="Path 7697"
          d="m18.24 25.366-3.242 1.572a22.338 22.338 0 0 1-3.239-1.572C5.144 21.515-2.048 13.496.542 5.155c2.572-8.282 13.211-5.3 14.459-.028 1.246-5.268 11.887-8.254 14.458.028 2.591 8.343-4.6 16.36-11.217 20.213Z"
        />
        <path
          data-name="Path 7698"
          d="M18.239 25.366 15 26.937a22.433 22.433 0 0 1-3.239-1.571 28.47 28.47 0 0 1-2.36-1.539c14.12-4.515 18.041-15.372 19.125-20.729a8.566 8.566 0 0 1 .932 2.057c2.591 8.343-4.6 16.36-11.217 20.213Z"
        />
        <path
          data-name="Path 7699"
          d="M18.239 25.366 15 26.937a22.433 22.433 0 0 1-3.239-1.571 28.47 28.47 0 0 1-2.36-1.539c14.12-4.515 18.041-15.372 19.125-20.729a8.566 8.566 0 0 1 .932 2.057c2.591 8.343-4.6 16.36-11.217 20.213Z"
        />
        <path
          data-name="Path 7700"
          d="M2.132 9.232c-1.048-3.616 1.434-7.859 5.43-7.778a4.311 4.311 0 0 1 1.518.293v.023a9.539 9.539 0 0 0-2.668.745 6.882 6.882 0 0 0-3.603 4.023 13.043 13.043 0 0 0-.654 2.7h-.023Z"
        />
      </g>
    </svg>
  );
}
